import { Link, NavLink } from 'react-router-dom'
import type { ReactNode } from 'react'
import '@/features/wealth/wealth.css'
export function PublicLayout({ children }: { children: ReactNode }) {
  return (
    <div className="wealth-public">
      <a className="wealth-skip" href="#main-content">
        К содержимому
      </a>
      <header className="wealth-public-header">
        <Link to="/" className="wealth-logo">
          <span>э</span> Эльвирка<span className="wealth-logo-dot">.</span>
        </Link>
        <nav aria-label="Основная навигация">
          <NavLink to="/demo">Демопортфель</NavLink>
          <NavLink to="/lab">Проверить доходность</NavLink>
          <Link to="/login">Войти ↗</Link>
        </nav>
      </header>
      <main id="main-content">{children}</main>
      <footer className="wealth-footer">
        <Link to="/">Эльвирка · понятный учёт капитала</Link>
        <span>
          Оценки и сценарии помогают разобраться в цифрах. Результат инвестиций
          не гарантирован.
        </span>
      </footer>
    </div>
  )
}
